'use strict';

const BaseScene = require('./base-scene');
const Button = require('../ui/button');
const { COLORS, GAME_WIDTH } = require('../config/constants');
const { drawGlowText, drawText, drawPanel, drawPlane } = require('../ui/draw');
const { getPlaneRadiance } = require('../ui/plane-radiance');

class HomeScene extends BaseScene {
  enter() {
    const centerX = GAME_WIDTH / 2;
    this.continueButton = new Button({ x: centerX - 270, y: 695, width: 540, height: 92, label: '继续游戏', onTap: () => this.app.switchScene('game', { level: this.app.profile.highestUnlockedLevel }) });
    this.dailyButton = new Button({ x: 70, y: 815, width: 285, height: 82, label: '每日挑战', variant: 'secondary', fontSize: 28, onTap: () => this.app.switchScene('dailyChallenges') });
    this.leaderboardButton = new Button({ x: 395, y: 815, width: 285, height: 82, label: '排行榜', variant: 'secondary', fontSize: 28, onTap: () => this.app.switchScene('leaderboard') });
    this.cosmeticsButton = new Button({ x: 70, y: 925, width: 285, height: 82, label: '外观', variant: 'secondary', fontSize: 28, onTap: () => this.app.switchScene('cosmetics') });
    this.levelsButton = new Button({ x: 395, y: 925, width: 285, height: 82, label: '关卡选择', variant: 'secondary', fontSize: 28, onTap: () => this.app.switchScene('levelSelect') });
    this.feedbackButton = new Button({ x: 70, y: 1040, width: 285, height: 72, label: this.feedbackLabel(), variant: 'secondary', fontSize: 22, onTap: () => this.toggleFeedback() });
    this.sensitivityButton = new Button({ x: 395, y: 1040, width: 285, height: 72, label: this.sensitivityLabel(), variant: 'secondary', fontSize: 22, onTap: () => this.toggleSensitivity() });
    this.buttons = [this.continueButton, this.dailyButton, this.leaderboardButton, this.cosmeticsButton, this.levelsButton, this.feedbackButton, this.sensitivityButton];
  }

  feedbackLabel() {
    return this.app.settings.feedbackEnabled ? '音效/震动：开' : '音效/震动：关';
  }

  toggleFeedback() {
    this.app.settings.feedbackEnabled = !this.app.settings.feedbackEnabled;
    this.app.storage.saveSettings(this.app.settings);
    this.app.feedback.setEnabled(this.app.settings.feedbackEnabled);
    this.feedbackButton.label = this.feedbackLabel();
    if (this.app.settings.feedbackEnabled) this.app.feedback.preview();
  }

  sensitivityLabel() {
    const labels = { low: '低', medium: '中', high: '高' };
    return `触板灵敏度：${labels[this.app.settings.touchSensitivity] || '中'}`;
  }

  toggleSensitivity() {
    const levels = ['low', 'medium', 'high'];
    const current = levels.indexOf(this.app.settings.touchSensitivity);
    this.app.settings.touchSensitivity = levels[(current + 1) % levels.length];
    this.app.storage.saveSettings(this.app.settings);
    this.sensitivityButton.label = this.sensitivityLabel();
  }

  currentTitle() {
    const dashboard = this.app.dashboard || {};
    const selected = dashboard.selection && dashboard.selection.title;
    const item = (dashboard.cosmetics || []).find((cosmetic) => cosmetic.key === selected);
    return item ? item.label : '飞行员';
  }

  render(ctx) {
    const previewLevel = Math.max(1, Math.min(99, Number(this.app.profile.highestUnlockedLevel) || 1));
    const previewColor = this.app.cosmeticColor('PLANE', COLORS.cyan);
    const previewRadiance = getPlaneRadiance(previewLevel, previewColor, this.app.elapsed);
    drawGlowText(ctx, '星际闪避', GAME_WIDTH / 2, 135, 72, COLORS.cyan);
    drawText(ctx, '穿越弹幕 · 征服 99 关', GAME_WIDTH / 2, 205, 25, COLORS.muted);
    drawPlane(ctx, GAME_WIDTH / 2, 335, 1.15, previewColor, previewRadiance);
    drawPanel(ctx, 90, 445, 570, 205);
    const level = (this.app.profile.playerLevel && this.app.profile.playerLevel.level)
      || (this.app.dashboard && this.app.dashboard.playerLevel && this.app.dashboard.playerLevel.level) || 1;
    const levelInfo = (this.app.dashboard && this.app.dashboard.playerLevel) || this.app.profile.playerLevel || { currentXp: 0, xpToNextLevel: 100 };
    drawText(ctx, `${this.app.profile.nickname || '飞行员'} · ${this.currentTitle()}`, GAME_WIDTH / 2, 485, 27, COLORS.text, 'center', 'bold');
    drawText(ctx, `等级 ${level} · 总经验 ${this.app.profile.totalXp || 0}`, GAME_WIDTH / 2, 535, 24, COLORS.cyan);
    drawText(
      ctx,
      `最高解锁  ${this.app.profile.highestUnlockedLevel} / 99`,
      GAME_WIDTH / 2,
      580,
      28,
      COLORS.success,
      'center',
      'bold'
    );
    const ratio = Math.max(0, Math.min(1, Number(levelInfo.currentXp || 0) / Math.max(1, Number(levelInfo.xpToNextLevel || 1))));
    ctx.fillStyle = 'rgba(145,164,201,.18)'; ctx.fillRect(145, 615, 460, 10);
    ctx.fillStyle = COLORS.cyan; ctx.fillRect(145, 615, 460 * ratio, 10);
    this.drawButtons(ctx);
    if (this.app.offline || this.app.pendingRunFinishes.length) {
      drawText(ctx, '成绩待同步', GAME_WIDTH / 2, 1190, 24, COLORS.warning);
    }
  }
}

module.exports = HomeScene;
